import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ActualMatch } from '@/entities/forecast/ui/ActualMatch';
import { ResultMatch } from '@/entities/forecast/ui/ResultMatch';
import { TimerMatch } from '@/entities/forecast/ui/TimerMatch';
import { GiftMatch } from '@/entities/forecast/ui/GiftMatch';
import { FonbetBanner } from '@/shared/ui/FonbetBanner';
import { useStore } from '@/app/providers/StoreProvider';
import { IMatch } from '@/entities/forecast/types';
import { TicketMatch } from '@/entities/forecast/ui/TicketMatch';
import { Loading } from '@/shared/ui/Loading';
import dayjs from '@/shared/lib/dayjs';
import { FinishMatch } from '@/entities/forecast/ui/FinishMatch';



export const SetForecastPage = observer(() => {
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const { forecastStore, userStore } = useStore();

  const [match, setMatch] = useState<IMatch | null>(null)


  useEffect(()=>{
      if(!id) return
      const fetchMatch = async() => {
          if(forecastStore.bets.length == 0) {
            await forecastStore.getBets(+id);
          }

          const match = await forecastStore.getMatch(id);
          if(match)
            setMatch(match)
      }
      fetchMatch()

      const intervalId = setInterval(() => {
        fetchMatch()
      }, 60000);

      return () => {
        clearInterval(intervalId);
      };

  },[id]);


  if(forecastStore.loading || !match) return <Loading/>

  const isActual = match.actual;
  const isAcceptingBets = match.acceptingBets;
  const isBet = forecastStore.isBet(userStore.user);

  const isNotStarted = (date:string) =>{
    return dayjs(date).isAfter(dayjs());
  }

  return (
    <>
    <div className="forecast-page set-forecast">
      <div className="container">
          <FonbetBanner link={match.fonbetLink}/>
          <FinishMatch match={match}/>
          <ActualMatch match={match} isActual={isActual} isBet={isBet} showTitle={false}/>
          <ResultMatch isActual={isActual} isAcceptingBets={isAcceptingBets} isBet={isBet}/>
          {isActual
          ?isNotStarted(match.endBettingTime)?<TimerMatch text={'Возможность сделать прогноз закроется через:'} date={match.endBettingTime}/>:null
          :isNotStarted(match.startBettingTime)?<TimerMatch text={'Прогнозы на этот матч будут открыты через:'} date={match.startBettingTime} /> :null
          }
          <GiftMatch match={match} isActual={isActual}/>
      </div>
    </div>

    <TicketMatch match={match} isActual={isActual} isAcceptingBets={isAcceptingBets} isBet={isBet}/>
    </>
  );
});
